import React from "react";
import HeroSection       from "./sections/HeroSection";
import AboutSection      from "./sections/AboutSection";
import ExperienceSection from "./sections/ExperienceSection";
import SkillsSection     from "./sections/SkillsSection";
import ProjectsSection   from "./sections/ProjectsSection";
import AchievementsSection from "./sections/AchievementsSection";
import ContactSection    from "./sections/ContactSection";

function HomePage() {
  return (
    <>
      <HeroSection />
      <ProjectsSection />
      <AchievementsSection />
      <SkillsSection />
      <ExperienceSection />
      <AboutSection />
      <ContactSection />
    </>
  );
}

export default HomePage;
